import { FinanceProgram, LenderProfiles } from '@trnsact/trnsact-shared-types';

export function getFinanceProgramSelectOption(
  financeProgram: FinanceProgram,
  lenderProfilesById: Record<string, LenderProfiles>
) {
  const financeProgramLenderProfileIds =
    financeProgram.financeProgramToLenderProfiles?.map(i => i?.lenderProfileId!) || [];
  const financeProgramLenderProfiles = financeProgramLenderProfileIds.map(id => lenderProfilesById[id]).filter(Boolean);

  return {
    label:
      financeProgram.nameInternal +
      (financeProgramLenderProfiles?.length
        ? ` - (${financeProgramLenderProfiles.map(lp => lp.lenderName).join(', ')})`
        : ``),
    value: financeProgram.financeProgramId,
  };
}
